import { ChartComponent } from '..'
import { Rect, createRect } from './rect'
import { Limits } from './limits'
import { Orientation } from './lines'

export type PatternType = 'diagonal-stripes' | 'horizontal-stripes'
export type Pattern = {
  type: PatternType
  color: string
  background?: string
  strokeWidth?: number
}

export type Bar = {
  label: string
  color: string
  x: number
  height: number
  pattern?: Pattern
  gradient?: boolean
}

export const createBar = (
  bar: Bar,
  position: number,
  height: number,
  width: number,
  offset: number,
  orientation: Orientation,
  limits: Limits
): ChartComponent<'line'>[] => {
  const rect: Rect =
    orientation === 'vertical'
      ? {
          x: position - width / 2,
          y: limits.y[0] + offset,
          width,
          height,
          fill: bar.color,
          label: bar.label,
          gradient: bar.gradient,
          orientation: 'vertical'
        }
      : {
          x: limits.x[0] + offset,
          y: position - width / 2,
          width: height,
          height: width,
          fill: bar.color,
          label: bar.label,
          gradient: bar.gradient,
          orientation: 'horizontal'
        }
  return [
    createRect(rect, limits),
    ...(bar.pattern
      ? [
          createRect(
            { ...rect, pattern: bar.pattern.type, fill: bar.pattern.color ?? rect.fill },
            limits
          )
        ]
      : [])
  ]
}

export const createBars = (
  bars: Bar[][],
  width: number,
  orientation: Orientation,
  limits: Limits
): ChartComponent<'line'>[] =>
  bars.flatMap((h, i) =>
    h.flatMap((v, j) =>
      createBar(
        bars[i][j],
        bars[i][j].x,
        bars[i][j].height,
        width,
        h.slice(0, j).reduce((acc, curr) => acc + curr.height, 0),
        orientation,
        limits
      )
    )
  )
